import * as actions from './actions'
import Fuse from 'fuse.js'

const initState = {
    customers: null,
    customersFused: null,
    customer: null,
    softwarePlans: null
}

export default function reducer(state = initState, action) {
    switch(action.type) {
        case actions.GET_CUSTOMERS_SUCCESS:
            return {
                ...state,
                ...{
                    customers: action.customers,
                    customersFused: new Fuse(action.customers || [], { keys: ['name'] })
                }
            }
        case actions.GET_CUSTOMER_SUCCESS:
            return {
                ...state,
                ...{
                    customer: action.customer
                }
            }
        case actions.GET_SOFTWARE_PLANS_SUCCESS:
            return {
                ...state,
                ...{
                    softwarePlans: action.softwarePlans.reduce((acc, plan) => {
                        acc[plan.id] = plan.code
                        return acc
                    }, {})
                }
            }
        case actions.SET_CUSTOMERS:
            return {
                ...state,
                ...{
                    customers: action.customers
                }
            }
        default:
            return state
    }
}